import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthenticationContext } from './Contexts';
import { ProtectedRoute } from './ProtectedRoute';
import { Home } from '../modules/home/components/Home';

import { ProfileAccount } from '../modules/personal-account/Component/PersonalAccount';
import { LandingPage } from './components/landing-page/LandingPage';
import { Login } from './components/LogIn/Login';

import { Client } from '../modules/client/components/Client';
import { Business } from '../modules/business/components/Business';
import { BusinessStore } from '../modules/business-store/components/BusinessStore';
import { RetailStore } from '../modules/retail-store/components/RetailStore';
import { Category } from '../modules/category/components/Category';
import { Department } from '../modules/department/components/Department';
import { Role } from '../modules/role/components/Role';
import { User } from '../modules/user-management/components/User';
import { ServiceItem } from '../modules/service-item/components/ServiceItem';
import { BusinessStoreOrder } from '../modules/business-store-order/components/BusinessStoreOrder';
import { RetailStoreOrder } from '../modules/retail-store-order/components/RetailStoreOrder';
import { CustomerOrder } from '../modules/customer-order/components/CustomerOrder';
import { MediaFile } from '../modules/media/components/MediaFile';
import Orders from '../modules/orders/Orders';
import { UserInfoForm } from '../modules/user-order/components/user-info-form/UserInfoForm';
import { ClothesSeletion } from '../modules/user-order/components/clothes-seletion/ClothesSeletion';
import { PickAndDrop } from '../modules/user-order/components/pick-and-drop/PickAndDrop';
import { Login as CustomerLogin } from '../collectionCenter/modules/Login';
import Dashboard from '../collectionCenter/modules/Dashboard';
import CollectionPoint from '../collectionCenter/modules/CollectionPoint';
import EmployeeSetup from '../collectionCenter/modules/EmployeeSetup';
import { RetailStoreOrderDetails } from '../modules/retail-store-order/components/retail-store-order-detail/RetailStoreOrderDetails';
import { GenerateInvoices } from '../modules/business-invoices/components/generate-invoices/GenerateInvoices';
import { BusinessInvoices } from '../modules/business-invoices/components/BusinessInvoices';
import { BusinessOrderDetails } from '../modules/business-store-order/components/business-order-details/BusinessOrderDetails';
import { CreateBusinessStore } from '../modules/business-store/components/create-business-store/CreateBusinessStore';
import { CreateBusiness } from '../modules/business/components/create-business/CreateBusiness';
import { BusinessDeliveryNotes } from '../modules/business-delivery-notes/components/BusinessDeliveryNotes';
import { CreateRetailStore } from '../modules/retail-store/components/create-retail-store/CreateRetailStore';
import { RetailInvoices } from '../modules/retail-invoices/components/RetailInvoices';
import { AddBusinessPayment } from '../modules/business-payment/components/add-business-payment/AddBusinessPayment';
import { GenerateRetailInvoice } from '../modules/retail-invoices/components/generate-retail-invoice/GenerateRetailInvoice';
import { AddRetailPayment } from '../modules/retail-payment/components/add-retail-payment/AddRetailPayment';
import { AddCustomerPayment } from '../modules/customer-payment/components/add-customer-payment/AddCustomerPayment';
import { RetailStoreCustomerDetails } from '../modules/retail-store-order/components/retail-store-customer-details/RetailStoreCustomerDetails';
import { CustomerInvoices } from '../modules/customer-invoices/components/CustomerInvoices';
import { GenerateCustomerInvoice } from '../modules/customer-invoices/components/generate-customer-invoice/GenerateCustomerInvoice';
import { Customer } from '../modules/customer/components/Customer';
import { CreateCustomer } from '../modules/customer/components/create-customer/CreateCustomer';
import { CustomerDetails } from '../modules/customer-order/components/customer-details/CustomerDetails';
import { CustomerCardOrder } from '../modules/orders/CustomerCardOrder';
import { CustomerOrderDetails } from '../modules/customer-order/components/customer-order-detail/CustomerOrderDetails';
import { PickupDeliveryAddress } from '../modules/orders/components/pickup-delivery/PickupDeliveryAddress';
import { ServiceType } from '../modules/user-order/components/select-service-type/ServiceType';
import { VerifyBusinessOrderDetails } from '../modules/business-order-verify/components/verify-business-order-details/VerifyBusinessOrderDetails';
import { BusinessOrderVerify } from '../modules/business-order-verify/components/BusinessOrderVerify';
import { DeliveryItemDetails } from '../modules/business-delivery-notes/components/delivery-item-details/DeliveryItemDetails';
import { OrderLogin } from '../orderCenter/modules/login/OrderLogin';
import { OrderHome } from '../orderCenter/modules/order-home/OrderHome';
import { PickupOrder } from '../orderCenter/modules/pickup-order/PickupOrder';
import { UpdateOrder } from '../orderCenter/modules/update-order/UpdateOrder';
import { OrderServiceType } from '../orderCenter/modules/order-service-type/OrderServiceType';
import { BusinessStoreHome } from '../modules/user-order/components/business-store-home/BusinessStoreHome';
import { ServiceTypeDetail } from '../modules/orders/components/service-type-detail/ServiceTypeDetail';
import { InhouseSales } from '../modules/reports/components/inhouse-sales/InhouseSales';
import { BusinessSales } from '../modules/reports/components/business-sales/BusinessSales';
import { BusinessDepartment } from '../modules/business-department/components/BusinessDepartment';
import { CreateBusinessDepartment } from '../modules/business-department/components/create-business-department/CreateBusinessDepartment';
import { ProductMaster } from '../modules/service-item/components/product-master/ProductMaster';
import { CreateProductMaster } from '../modules/service-item/components/product-master/CreateProductMaster';
import { MappedServiceItem } from '../modules/business-department/components/mapped-service-item/MappedServiceItem';
import { CreatePriceMaster } from '../modules/service-item/components/price-master/CreatePriceMaster';
import { PriceMaster } from '../modules/service-item/components/price-master/PriceMaster';
import { CostCenter } from '../modules/cost-center/components/CostCenter';
import { ProcessingCenter } from '../modules/processing-center/components/ProcessingCenter';
import {CreateCostCenter} from '../modules/cost-center/components/CreateCostCenter';
import { CreateProcessingCenter } from '../modules/processing-center/components/CreateProcessingCenter';
import { CreateUser } from '../modules/user-management/components/CreateUser';
import { ProductMasterDetails } from '../modules/service-item/components/product-master/ProductMasterDetails';
import { ProductPriceMasterDetail } from '../modules/service-item/components/product-master/ProductPriceMasterDetail';
import { PriceMasterDetail } from '../modules/service-item/components/price-master/PriceMasterDetail';
import { InhouseBatch } from '../modules/reports/components/inhouse-batch/InhouseBatch';
import { BusinessBatch } from '../modules/reports/components/business-batch/BusinessBatch';
import { DailyCustomerRevenue } from '../modules/reports/components/daily-customer-revenue/DailyCustomerRevenue';
import { DailyRevenue } from '../modules/reports/components/daily-revenue/DailyRevenue';
import { OpenOrderReport } from '../modules/reports/components/open-order-report/OpenOrderReport';
import { PackagingLabel } from '../modules/label-management/components/packagingLabel';
import { TrollyManagement } from '../modules/label-management/components/trollyManagement';
import { ReceiveTrolly } from '../modules/label-management/components/ReceiveTrolly';
import { DeliveryTrolly } from '../modules/label-management/components/DeliveryTrolly';
import { WashingReport } from '../modules/process-management/components/WashingReport';
import { WashingLoad } from '../modules/process-management/components/WashingLoad';
import { GarmentPackagingLabel } from '../modules/label-management/components/garmentPackagingLabel';
import { GarmentDeliveryNote } from '../modules/label-management/components/garmentDeliveryNote';
import { GarmentPackagingOrderDetail } from '../modules/label-management/components/garmentPackagingOrderDetail';
import { AddEmployee } from '../collectionCenter/modules/AddEmployee';
import { ReceiveDelivery } from '../collectionCenter/modules/ReceiveDelivery';
import { GenerateGNR } from '../collectionCenter/modules/GenerateGnr';
import { CollectionCenterOrder } from '../collectionCenter/modules/CollectionCenterOrder';
import { DeliveryToEmp } from '../collectionCenter/modules/DeliveryToEmp';
import { GarmentSummaryNote } from '../modules/garment-summary-note/GarmentSummaryNote';
import BusinessUser from '../modules/business-user-management/BusinessUser';
import { CreateBusinessUser } from '../modules/business-user-management/CreateBusinessUser';
import { TrollyInventoryReport } from '../modules/label-management/components/trollyInventoryReport';
import { RevenuePerKiloReport } from '../modules/reports/components/revenue-per-kilo-report/RevenuePerKiloReport';
import { CustomerSaleSummary } from '../modules/reports/components/customer-sale-summary/CustomerSaleSummary';
import { CustomerRewashSummary } from '../modules/reports/components/customer-rwash-summary/CustomerRewashSummary';
import { CustomerKiloQtyRevenueReport } from '../modules/reports/components/customer-kilo-qty-revenue/CustomerKiloQtyRevenueReport';

export const Routers = () => {
  const { token, urlPath } = useContext(AuthenticationContext);
  const role = localStorage.getItem('userRole') || '';
  const type = localStorage.getItem('userType');

  return (
    <Routes>
      <Route
        path="/"
        element={
          urlPath.includes('retailCustomerOrder') ? (
            <UserInfoForm />
          ) : !token ? (
            <Login />
          ) : role == 'SUPER_ADMIN' ? (
            <Navigate to="/client" replace />
          ) : ['ACCOUNTANT','ADMIN_USER', 'CLIENT_ADMIN'].includes(role) ? (
            <Navigate to="/business" replace />
          ) : role === 'PACK_USER' ? (
            <Navigate to="/packaging-label" replace />
          ) : ['CLIENTS', 'PRODUCTION', 'DATA_ENTRY'].includes(role) ? (
            <Navigate to="/business-store-order" replace />
          ) : type == 'Retail' ? (
            <Navigate to="/retail-store-order" replace />
          ) : type == 'Customer' ? (
            <Navigate to="/customer" replace />
          ) : (
            <Navigate to="/business" replace />
          )
        }
      />
      <Route
        path="/login"
        element={
          !token ? (
            <Login />
          ) : role == 'SUPER_ADMIN' ? (
            <Navigate to="/client" replace />
          ) : (
            <Navigate to="/business" replace />
          )
        }
      />
      {/* collection center */}
      <Route path="/collectionCenter" element={<CustomerLogin />} />
      <Route path="/collectionCenter/login" element={<CustomerLogin />} />
      <Route
        path="/collectionCenter/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/collectionCenter/collectionPoint"
        element={
          <ProtectedRoute>
            <CollectionPoint />
          </ProtectedRoute>
        }
      />
      <Route
        path="/collectionCenter/employeeSetup"
        element={
          <ProtectedRoute>
            <EmployeeSetup />
          </ProtectedRoute>
        }
      />
      <Route
        path="/collectionCenter/addEmp"
        element={
          <ProtectedRoute>
            <AddEmployee />
          </ProtectedRoute>
        }
      />
      <Route
        path="/collectionCenter/receiveDelivery"
        element={
          <ProtectedRoute>
            <ReceiveDelivery />
          </ProtectedRoute>
        }
      />
      <Route
        path="/collectionCenter/generatedGnr"
        element={
          <ProtectedRoute>
            <GenerateGNR />
          </ProtectedRoute>
        }
      />
      <Route
        path="/collectionCenter/collectionOrder"
        element={
          <ProtectedRoute>
            <CollectionCenterOrder />
          </ProtectedRoute>
        }
      />
      <Route
        path="/collectionCenter/deliveryEmp"
        element={
          <ProtectedRoute>
            <DeliveryToEmp />
          </ProtectedRoute>
        }
      />

      {/* Order Center */}
      <Route path="/OrderCenter" element={<OrderLogin />} />
      <Route path="/OrderCenter/login" element={<OrderLogin />} />
      <Route path="/OrderCenter/home" 
        element={
          <ProtectedRoute>
            <OrderHome />
          </ProtectedRoute>
        } />
      <Route path="/OrderCenter/pickup-order" element={<ProtectedRoute><PickupOrder /></ProtectedRoute>} />
      <Route path="/OrderCenter/update-order" element={<ProtectedRoute><UpdateOrder /></ProtectedRoute>} />
      <Route path="/OrderCenter/pickup-order">
          <Route path="order-service-type" element={<ProtectedRoute><OrderServiceType/></ProtectedRoute>} />
      </Route>

      {/* Retail App */}
      {/* <Route path="/retail-app" element={<RetailLoginPage />} />
      <Route path="/retail-app/login" element={<RetailLoginPage />} />
      <Route path="/retail-app/home" element={<RetailHomePage />} /> */}

      <Route
        path="/retail-store"
        element={
          <ProtectedRoute>
            <RetailStore />
          </ProtectedRoute>
        }
      />
      <Route
        path="/client"
        element={
          <ProtectedRoute>
            <Client />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business"
        element={
          <ProtectedRoute>
            <Business />
          </ProtectedRoute>
        }
      />
      <Route
        path="/create-business"
        element={
          <ProtectedRoute>
            <CreateBusiness />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business-store"
        element={
          <ProtectedRoute>
            <BusinessStore />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business-department"
        element={
          <ProtectedRoute>
            <BusinessDepartment />
          </ProtectedRoute>
        }
      />
      <Route path="/business-department">
        <Route
          path="create-business-department"
          element={
            <ProtectedRoute>
              <CreateBusinessDepartment />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="/business-department">
        <Route
          path="mapped-service-item"
          element={
            <ProtectedRoute>
              <MappedServiceItem />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route
        path="/create-business-store"
        element={
          <ProtectedRoute>
            <CreateBusinessStore />
          </ProtectedRoute>
        }
      />

      <Route
        path="/business-store-order"
        element={
          <ProtectedRoute>
            <BusinessStoreOrder />
          </ProtectedRoute>
        }
      />

      <Route path="/business-store-order">
        <Route
          path="order-details"
          element={
            <ProtectedRoute>
              <BusinessOrderDetails />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route path="/business-store-order">
        <Route
          path="orders"
          element={
            <ProtectedRoute>
              <Orders />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route
        path="/business-store-order">
        <Route
          path="order-summary"
          element={
            <ProtectedRoute>
              <ServiceTypeDetail />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="/business-store-order">
        <Route
          path="add-payment"
          element={
            <ProtectedRoute>
              <AddBusinessPayment />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route
        path="/business-verify"
        element={
          <ProtectedRoute>
            <BusinessOrderVerify />
          </ProtectedRoute>
        }
      />

      <Route path="/business-verify">
        <Route
          path="order-details-verify"
          element={
            <ProtectedRoute>
              <VerifyBusinessOrderDetails />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route
        path="/garment-summary-note"
        element={
          <ProtectedRoute>
            <GarmentSummaryNote />
          </ProtectedRoute>
        }
      />

      <Route
        path="/business-invoices"
        element={
          <ProtectedRoute>
            <BusinessInvoices />
          </ProtectedRoute>
        }
      />

      <Route path="/business-invoices">
        <Route
          path="generate-invoices"
          element={
            <ProtectedRoute>
              <GenerateInvoices />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route
        path="/business-payments"
        element={
          <ProtectedRoute>
            <AddBusinessPayment />
          </ProtectedRoute>
        }
      />

      <Route
        path="/business-delivery-notes"
        element={
          <ProtectedRoute>
            <BusinessDeliveryNotes />
          </ProtectedRoute>
        }
      />
      <Route path="/business-delivery-notes">
        <Route
          path="delivery-item-details"
          element={
            <ProtectedRoute>
              <DeliveryItemDetails />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route
        path="/department"
        element={
          <ProtectedRoute>
            <Department />
          </ProtectedRoute>
        }
      />
      <Route
        path="/user"
        element={
          <ProtectedRoute>
            <User />
          </ProtectedRoute>
        }
      />
      <Route path="/user">
        <Route
          path="create-user"
          element={
            <ProtectedRoute>
              <CreateUser/>
            </ProtectedRoute>
          }
        />
      </Route>
      <Route
        path="/business-user"
        element={
          <ProtectedRoute>
            <BusinessUser />
          </ProtectedRoute>
        }
      />
      <Route path="/business-user">
        <Route
          path="create-business-user"
          element={
            <ProtectedRoute>
              <CreateBusinessUser/>
            </ProtectedRoute>
          }
        />
      </Route>
      <Route
        path="/category"
        element={
          <ProtectedRoute>
            <Category />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cost-center"
        element={
          <ProtectedRoute>
            <CostCenter />
          </ProtectedRoute>
        }
      />
      <Route path="/cost-center">
        <Route
          path="create-cost-center"
          element={
            <ProtectedRoute>
              <CreateCostCenter />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route
        path="/processing-center"
        element={
          <ProtectedRoute>
            <ProcessingCenter />
          </ProtectedRoute>
        }
      />
      <Route path="/processing-center">
        <Route
          path="create-processing-center"
          element={
            <ProtectedRoute>
              <CreateProcessingCenter />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route
        path="/role"
        element={
          <ProtectedRoute>
            <Role />
          </ProtectedRoute>
        }
      />
      <Route
        path="/home"
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <ProfileAccount />
          </ProtectedRoute>
        }
      />

      {/* <Route
        path="/service-item"
        element={
          <ProtectedRoute>
            <ServiceItem />
          </ProtectedRoute>
        }
      /> */}
      <Route
        path="/product-master"
        element={
          <ProtectedRoute>
            <ProductMaster />
          </ProtectedRoute>
        }
      />
      <Route path="/product-master">
        <Route
          path="create-product-master"
          element={
            <ProtectedRoute>
              <CreateProductMaster/>
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="/product-master">
        <Route
          path="product-master-details"
          element={
            <ProtectedRoute>
              <ProductMasterDetails />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="/product-master">
        <Route
          path="price-master-detail"
          element={
            <ProtectedRoute>
              <ProductPriceMasterDetail/>
            </ProtectedRoute>
          }
        />
      </Route>
      <Route
        path="/price-master"
        element={
          <ProtectedRoute>
            <PriceMaster />
          </ProtectedRoute>
        }
      />
      <Route path="/price-master">
        <Route
          path="create-price-master"
          element={
            <ProtectedRoute>
              <CreatePriceMaster/>
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="/price-master">
        <Route
          path="price-master-detail"
          element={
            <ProtectedRoute>
              <PriceMasterDetail/>
            </ProtectedRoute>
          }
        />
      </Route>

      <Route
        path="/retail-store-order"
        element={
          <ProtectedRoute>
            <RetailStoreOrder />
          </ProtectedRoute>
        }
      />

      <Route path="/retail-store-order">
        <Route
          path="customer-details"
          element={
            <ProtectedRoute>
              <RetailStoreCustomerDetails />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route path="/retail-store-order">
      <Route
        path="orders"
        element={
          <ProtectedRoute>
            <Orders />
          </ProtectedRoute>
        }
      />
      </Route>

      <Route path="/retail-store-order">
        <Route
          path="order-details"
          element={
            <ProtectedRoute>
              <RetailStoreOrderDetails />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route path="/retail-store-order">
        <Route
          path="add-payment"
          element={
            <ProtectedRoute>
              <AddRetailPayment />
            </ProtectedRoute>
          }
        />
      </Route>

       <Route
          path="/create-retail-store"
          element={
            <ProtectedRoute>
              <CreateRetailStore />
            </ProtectedRoute>
          }
        />

      <Route
        path="/retail-invoices"
        element={
          <ProtectedRoute>
            <RetailInvoices />
          </ProtectedRoute>
        }
      />

      <Route path="/retail-invoices">
        <Route
          path="generate-invoices"
          element={
            <ProtectedRoute>
              <GenerateRetailInvoice />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route
        path="/retail-payments"
        element={
          <ProtectedRoute>
            <AddRetailPayment />
          </ProtectedRoute>
        }
      />

      <Route
        path="/customer-order"
        element={
          <ProtectedRoute>
            <CustomerOrder />
          </ProtectedRoute>
        }
      />

      <Route path="/customer-order">
        <Route
          path="order-details"
          element={
            <ProtectedRoute>
              <CustomerOrderDetails />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route
        path="/customer-order">
        <Route
          path="pick-and-drop"
          element={
            <ProtectedRoute>
              <PickupDeliveryAddress />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route
        path="/customer-order">
        <Route
          path="card-details"
          element={
            <ProtectedRoute>
              <CustomerCardOrder />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route
        path="/customer-order">
        <Route
          path="customer-details"
          element={
            <ProtectedRoute>
              <CustomerDetails />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route
        path="/customer"
        element={
          <ProtectedRoute>
            <Customer />
          </ProtectedRoute>
        }
      />
      <Route
        path="/customer">
        <Route
          path="create-customer"
          element={
            <ProtectedRoute>
              <CreateCustomer />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route
        path="/customer">
        <Route
          path="create-order"
          element={
            <ProtectedRoute>
              <CustomerCardOrder />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route
        path="/customer">
        <Route
          path="pick-and-drop"
          element={
            <ProtectedRoute>
              <PickupDeliveryAddress />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route
        path="/customer-invoices"
        element={
          <ProtectedRoute>
            <CustomerInvoices />
          </ProtectedRoute>
        }
      />

      <Route path="/customer-invoices">
        <Route
          path="generate-invoices"
          element={
            <ProtectedRoute>
              <GenerateCustomerInvoice />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route
        path="/customer-payments"
        element={
          <ProtectedRoute>
            <AddCustomerPayment />
          </ProtectedRoute>
        }
      />

      <Route
        path="/orders"
        element={
          <ProtectedRoute>
            <Orders />
          </ProtectedRoute>
        }
      />

      <Route
        path="/packaging-label"
        element={
          <ProtectedRoute>
            <PackagingLabel />
          </ProtectedRoute>
        }
      />
      <Route
        path="/garment-packaging-label"
        element={
          <ProtectedRoute>
            <GarmentPackagingLabel />
          </ProtectedRoute>
        }
      />
      <Route path="/garment-packaging-label">
        <Route
          path="order-details"
          element={
            <ProtectedRoute>
              <GarmentPackagingOrderDetail />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route
        path="/trolly-management"
        element={
          <ProtectedRoute>
            <TrollyManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/garment-delivery-trolly"
        element={
          <ProtectedRoute>
            <GarmentDeliveryNote />
          </ProtectedRoute>
        }
      />
      <Route 
        path='/trolly-inventory-report'
        element={
          <ProtectedRoute>
            <TrollyInventoryReport />
          </ProtectedRoute>
        }
      />
      <Route
        path="/delivery-trolly"
        element={
          <ProtectedRoute>
            <DeliveryTrolly />
          </ProtectedRoute>
        }
      />
      <Route
        path="/receive-trolly"
        element={
          <ProtectedRoute>
            <ReceiveTrolly />
          </ProtectedRoute>
        }
      />
      <Route
        path="/washingLoad"
        element={
          <ProtectedRoute>
            <WashingLoad/>
          </ProtectedRoute>
        }
      />
      <Route
        path="/washingReport"
        element={
          <ProtectedRoute>
            <WashingReport />
          </ProtectedRoute>
        }
      />

      <Route
        path="/mediafile"
        element={
          <ProtectedRoute>
            <MediaFile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/inhouse"
        element={
          <ProtectedRoute>
            <InhouseSales />
          </ProtectedRoute>
        }
      />
      <Route
        path="/inhouse-batch"
        element={
          <ProtectedRoute>
            <InhouseBatch />
          </ProtectedRoute>
        }
      />
      <Route
        path="/businesssales"
        element={
          <ProtectedRoute>
            <BusinessSales />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business-batch"
        element={
          <ProtectedRoute>
            <BusinessBatch />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dailyRevenue"
        element={
          <ProtectedRoute>
            <DailyRevenue />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dailyCustomerRevenue"
        element={
          <ProtectedRoute>
            <DailyCustomerRevenue />
          </ProtectedRoute>
        }
      />
      <Route
        path="/openOrderReport"
        element={
          <ProtectedRoute>
            <OpenOrderReport />
          </ProtectedRoute>
        }
      />
      <Route
        path="/revenueByKiloReport"
        element={
          <ProtectedRoute>
            <RevenuePerKiloReport />
          </ProtectedRoute>
        }
      />
      <Route
        path="/customerSaleSummary"
        element={
          <ProtectedRoute>
            <CustomerSaleSummary />
          </ProtectedRoute>
        }
      />
      <Route
        path="/customerRewashSummary"
        element={
          <ProtectedRoute>
            <CustomerRewashSummary />
          </ProtectedRoute>
        }
      />
      <Route
        path="/customerKiloQtyRevenue"
        element={
          <ProtectedRoute>
            <CustomerKiloQtyRevenueReport />
          </ProtectedRoute>
        }
      />
      <Route path="/retailCustomerOrder" element={<UserInfoForm />} />
      <Route path="/businessCustomerOrder" element={<UserInfoForm />} />
      <Route path="/business-clothes-selection" element={<ClothesSeletion />} />
      <Route path="/clothes-selection" element={<ClothesSeletion />} />
      <Route path="/checkout" element={<PickAndDrop />} />
      <Route path="/business-checkout" element={<PickAndDrop />} />
      {/* <Route path="/businessStoreOrder" element={<ClothesSeletion />} /> */}
      <Route path="/businessStoreOrder" element={<BusinessStoreHome />} />
      <Route path="/businessStoreOrder">
        <Route
          path="clothes-selection"
          element={
              <ClothesSeletion />
          }
        />
      </Route>
      <Route path="/businessStoreOrder">
        <Route
          path="update-order"
          element={
              <UpdateOrder/>
          }
        />
      </Route>
      <Route path="/service-type" element={<ServiceType/>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
